/**
 * House of Looney - Shipping Protection (required choice)
 * Shows "Protect your order?" above the cart total (cart drawer and cart page).
 * The shopper must pick "Yes, protect it" or "No thanks" before checkout works.
 * Yes = adds one Shipping Protection line at the product's current price.
 * No thanks = saved on the cart as an attribute so we don't ask again.
 * The price shown is read from the Shipping Protection product, so changing the
 * price in Shopify admin updates the button automatically.
 */
(function () {
  if (window.__hlShippingProtection) return;
  window.__hlShippingProtection = true;

  var HANDLE = 'shipping-protection';
  var VARIANT = 67967493013739; // Shipping Protection (fallback if the product lookup fails)
  var PRICE_CENTS = 395; // fallback only; real price is loaded from the product
  var DECLINE_KEY = 'Shipping Protection';
  var DECLINE_VALUE = 'Declined';

  // Free shipping progress bar (matches the "Free Shipping" automatic discount: US, $50+)
  var FREE_SHIP_CENTS = 5000;
  var FREE_SHIP_COUNTRY = 'US';
  var bar = { show: false, remaining: FREE_SHIP_CENTS, progress: 0 };

  var busy = false;
  var pending = false;
  var pendingChoice;
  var showError = false;
  // choice: 'yes' | 'no' | null (not decided yet)
  var state = { show: false, choice: null, price: PRICE_CENTS };

  function cartUrl() {
    return (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
  }

  function fetchCart() {
    return fetch(cartUrl() + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json();
    });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    });
  }

  function updateBar(cart, protCents, others) {
    var country = window.Shopify && window.Shopify.country;
    var eligibleCountry = !country || country === FREE_SHIP_COUNTRY;
    // Leave Shipping Protection out so the bar never promises free shipping early.
    var counted = Math.max(0, (cart.total_price || 0) - protCents);
    bar = {
      show: eligibleCountry && others > 0,
      remaining: Math.max(0, FREE_SHIP_CENTS - counted),
      progress: Math.min(100, Math.floor((counted / FREE_SHIP_CENTS) * 100))
    };
  }

  function analyze(cart) {
    var prot = [];
    var others = 0;
    var protCents = 0;
    (cart.items || []).forEach(function (item) {
      if (item.handle === HANDLE) {
        prot.push(item);
        protCents += item.final_line_price;
      } else {
        others += 1;
      }
    });
    updateBar(cart, protCents, others);
    var declined = !!(cart.attributes && cart.attributes[DECLINE_KEY] === DECLINE_VALUE);
    return {
      prot: prot,
      others: others,
      target: VARIANT,
      declined: declined,
      price: PRICE_CENTS
    };
  }

  function buildLines(a, want) {
    var lines = [];
    var kept = false;
    a.prot.forEach(function (item) {
      if (want && !kept && item.variant_id === a.target) {
        kept = true;
        if (item.quantity !== 1) lines.push({ id: item.key, quantity: 1 });
      } else {
        lines.push({ id: item.key, quantity: 0 });
      }
    });
    if (want && !kept) {
      lines.push({ merchandiseId: 'gid://shopify/ProductVariant/' + a.target, quantity: 1 });
    }
    return lines;
  }

  function applyLines(lines) {
    if (!lines.length) return Promise.resolve();

    var actions = window.Shopify && window.Shopify.actions;
    if (actions && typeof actions.updateCart === 'function') {
      return actions.updateCart({ lines: lines }, { event: { context: 'cart' } });
    }

    // Fallback for when the theme's cart actions are not available.
    var root = cartUrl();
    var chain = Promise.resolve();
    lines.forEach(function (line) {
      chain = chain.then(function () {
        if (line.id) return postJSON(root + '/change.js', { id: line.id, quantity: line.quantity });
        var variantId = Number(String(line.merchandiseId).split('/').pop());
        return postJSON(root + '/add.js', { items: [{ id: variantId, quantity: 1 }] });
      });
    });
    return chain.then(function () {
      window.location.reload();
    });
  }

  function setDeclined(declined) {
    var attributes = {};
    attributes[DECLINE_KEY] = declined ? DECLINE_VALUE : '';
    return postJSON(cartUrl() + '/update.js', { attributes: attributes });
  }

  /**
   * @param {'yes'|'no'} [choice] - what the shopper just clicked; omit to just keep things in sync.
   */
  function sync(choice) {
    if (busy) {
      pending = true;
      if (choice) pendingChoice = choice;
      return;
    }
    busy = true;
    render();

    fetchCart()
      .then(function (cart) {
        var a = analyze(cart);
        var current = a.prot.length > 0 ? 'yes' : a.declined ? 'no' : null;
        var next = choice || current;
        if (a.others === 0) next = current === 'no' ? 'no' : null;

        state = { show: a.others > 0, choice: next, price: a.price };
        if (next) showError = false;
        render();

        var steps = [];
        if (next === 'yes') {
          steps.push(function () { return applyLines(buildLines(a, true)); });
          if (a.declined) steps.push(function () { return setDeclined(false); });
        } else {
          steps.push(function () { return applyLines(buildLines(a, false)); });
          if (next === 'no' && !a.declined) steps.push(function () { return setDeclined(true); });
        }
        return steps.reduce(function (p, step) {
          return p.then(step);
        }, Promise.resolve());
      })
      .catch(function (error) {
        console.warn('[shipping-protection]', error);
      })
      .then(function () {
        busy = false;
        render();
        if (pending) {
          var next = pendingChoice;
          pending = false;
          pendingChoice = undefined;
          sync(next);
        }
      });
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  var STYLE =
    '.hl-protection{border:1px solid rgb(var(--color-foreground-rgb, 0 0 0) / .2);border-radius:8px;padding:12px 14px;display:flex;flex-direction:column;gap:10px;}' +
    '.hl-protection.is-error{border-color:#c0392b;box-shadow:0 0 0 1px #c0392b;}' +
    '.hl-protection__head{display:flex;flex-direction:column;gap:2px;}' +
    '.hl-protection__title{font-weight:600;font-size:14px;}' +
    '.hl-protection__desc{font-size:12px;opacity:.75;}' +
    '.hl-protection__actions{display:grid;grid-template-columns:1.4fr 1fr;gap:8px;}' +
    '.hl-protection__btn{font:inherit;font-size:13px;font-weight:600;padding:10px 8px;border-radius:6px;cursor:pointer;border:1px solid currentColor;background:transparent;color:inherit;line-height:1.2;}' +
    '.hl-protection__btn.is-selected{background:var(--color-foreground, #000);color:var(--color-background, #fff);border-color:var(--color-foreground, #000);}' +
    '.hl-protection__btn:disabled{opacity:.6;cursor:wait;}' +
    '.hl-protection__error{margin:0;font-size:12px;color:#c0392b;font-weight:600;}' +
    'body.hl-protection-pending .cart__checkout-button{opacity:.55;}' +
    'body.hl-protection-pending .additional-checkout-buttons{opacity:.4;pointer-events:none;filter:grayscale(1);}' +
    '.hl-ship-bar{padding:12px var(--cart-drawer-padding, 16px) 4px;display:flex;flex-direction:column;gap:8px;}' +
    '.cart-totals > .hl-ship-bar{padding:0;}' +
    '.hl-ship-bar__text{margin:0;font-size:13px;text-align:center;line-height:1.3;}' +
    '.hl-ship-bar__track{height:8px;border-radius:999px;background:rgb(var(--color-foreground-rgb, 0 0 0) / .12);overflow:hidden;}' +
    '.hl-ship-bar__fill{height:100%;width:0;border-radius:999px;background:var(--color-foreground, #000);transition:width .4s ease;}' +
    '.hl-delivery{margin:10px 0 0;font-size:14px;line-height:1.4;}';

  var TEMPLATE =
    '<div class="hl-protection__head">' +
    '<span class="hl-protection__title">Protect your order?</span>' +
    '<span class="hl-protection__desc">Lost, stolen, or damaged in transit? We’ll replace it.</span>' +
    '</div>' +
    '<div class="hl-protection__actions">' +
    '<button type="button" class="hl-protection__btn hl-protection__yes">Yes, protect it (+<span class="hl-protection__price"></span>)</button>' +
    '<button type="button" class="hl-protection__btn hl-protection__no">No thanks</button>' +
    '</div>' +
    '<p class="hl-protection__error" hidden>Please choose an option to continue to checkout.</p>';

  function ensureStyle() {
    if (document.getElementById('hl-protection-style')) return;
    var style = document.createElement('style');
    style.id = 'hl-protection-style';
    style.textContent = STYLE;
    document.head.appendChild(style);
  }

  function isPending() {
    return state.show && !state.choice;
  }

  function barSpots() {
    var spots = [];
    // Cart drawer: top of the scrolling cart area, above the items.
    document.querySelectorAll('#cart-drawer .cart-drawer__content').forEach(function (el) {
      if (el.querySelector('.cart-drawer__items') && !el.closest('template')) spots.push({ parent: el, before: el.firstChild });
    });
    // Cart page: above the totals.
    document.querySelectorAll('.cart-totals').forEach(function (el) {
      if (!el.closest('#cart-drawer')) spots.push({ parent: el, before: el.firstChild });
    });
    return spots;
  }

  function renderBar() {
    barSpots().forEach(function (spot) {
      var box = null;
      for (var i = 0; i < spot.parent.children.length; i++) {
        if (spot.parent.children[i].classList.contains('hl-ship-bar')) {
          box = spot.parent.children[i];
          break;
        }
      }
      if (!bar.show) {
        if (box) box.remove();
        return;
      }
      if (!box) {
        box = document.createElement('div');
        box.className = 'hl-ship-bar';
        box.innerHTML =
          '<p class="hl-ship-bar__text"></p>' +
          '<div class="hl-ship-bar__track" role="progressbar" aria-valuemin="0" aria-valuemax="100"><div class="hl-ship-bar__fill"></div></div>';
        spot.parent.insertBefore(box, spot.parent.firstChild);
      }
      var text = box.querySelector('.hl-ship-bar__text');
      var track = box.querySelector('.hl-ship-bar__track');
      var fill = box.querySelector('.hl-ship-bar__fill');
      if (text) {
        text.innerHTML =
          bar.remaining > 0
            ? 'You’re <strong>' + money(bar.remaining) + '</strong> away from <strong>FREE shipping</strong>'
            : 'You’ve unlocked <strong>FREE shipping!</strong>';
      }
      if (track) track.setAttribute('aria-valuenow', String(bar.progress));
      if (fill) fill.style.width = bar.progress + '%';
    });
  }

  function render() {
    ensureStyle();
    renderBar();
    document.body.classList.toggle('hl-protection-pending', isPending());

    var containers = document.querySelectorAll('.cart-totals__container');
    containers.forEach(function (container) {
      var parent = container.parentNode;
      if (!parent) return;
      var box = null;
      for (var i = 0; i < parent.children.length; i++) {
        if (parent.children[i].classList.contains('hl-protection')) {
          box = parent.children[i];
          break;
        }
      }

      if (!state.show) {
        if (box) box.remove();
        return;
      }

      if (!box) {
        box = document.createElement('div');
        box.className = 'hl-protection';
        box.innerHTML = TEMPLATE;
        parent.insertBefore(box, container);
      }

      var yes = box.querySelector('.hl-protection__yes');
      var no = box.querySelector('.hl-protection__no');
      var price = box.querySelector('.hl-protection__price');
      var error = box.querySelector('.hl-protection__error');

      if (price) price.textContent = money(state.price);
      if (yes) {
        yes.classList.toggle('is-selected', state.choice === 'yes');
        yes.setAttribute('aria-pressed', state.choice === 'yes' ? 'true' : 'false');
        yes.disabled = busy;
      }
      if (no) {
        no.classList.toggle('is-selected', state.choice === 'no');
        no.setAttribute('aria-pressed', state.choice === 'no' ? 'true' : 'false');
        no.disabled = busy;
      }
      var showErr = showError && isPending();
      box.classList.toggle('is-error', showErr);
      if (error) error.hidden = !showErr;
    });
  }

  function blockCheckout(event) {
    showError = true;
    render();
    event.preventDefault();
    event.stopImmediatePropagation();
    var box = document.querySelector('.hl-protection');
    if (box && box.scrollIntoView) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // Block the Checkout button until the shopper chooses.
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      if (target.closest('.hl-protection__yes')) {
        sync('yes');
        return;
      }
      if (target.closest('.hl-protection__no')) {
        sync('no');
        return;
      }
      if (isPending() && target.closest('.cart__checkout-button, button[name="checkout"], #checkout')) {
        blockCheckout(event);
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!isPending() || !form || form.id !== 'cart-form') return;
      var submitter = event.submitter;
      if (!submitter || submitter.name === 'checkout') blockCheckout(event);
    },
    true
  );

  var scheduled = false;
  function scheduleRender() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      var spots = barSpots();
      for (var s = 0; s < spots.length; s++) {
        var hasBar = spots[s].parent.querySelector(':scope > .hl-ship-bar');
        if ((bar.show && !hasBar) || (!bar.show && hasBar)) {
          render();
          return;
        }
      }
      var containers = document.querySelectorAll('.cart-totals__container');
      for (var i = 0; i < containers.length; i++) {
        var parent = containers[i].parentNode;
        var has = parent && parent.querySelector(':scope > .hl-protection');
        if ((state.show && !has) || (!state.show && has)) {
          render();
          return;
        }
      }
    }, 30);
  }

  function afterCartEvent(event) {
    var done = function () {
      setTimeout(function () {
        sync();
      }, 50);
    };
    if (event && event.promise && typeof event.promise.then === 'function') {
      event.promise.then(done, done);
    } else {
      done();
    }
  }

  document.addEventListener('shopify:cart:lines-update', afterCartEvent);
  document.addEventListener('shopify:cart:discount-update', afterCartEvent);

  function loadProduct() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'products/' + HANDLE + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (product) {
        var variant = product && product.variants && product.variants[0];
        if (variant) {
          VARIANT = variant.id;
          PRICE_CENTS = variant.price;
          state.price = PRICE_CENTS;
        }
      })
      .catch(function () {});
  }

  /* ---------------- Estimated delivery date (product pages) ----------------
   * In-house products (vendor "House of Looney") only: 3-7 business days
   * (ships next business day + USPS Ground Advantage 2-5 days + 1 day buffer).
   * Not shown on Printify items, pre-order/presale items, sold-out items,
   * Shipping Protection, or to visitors outside the US.
   */
  var DELIVERY_VENDOR = 'House of Looney';
  var DELIVERY_MIN_DAYS = 3;
  var DELIVERY_MAX_DAYS = 7;
  var deliveryText = null;

  function addBusinessDays(date, days) {
    var d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return d;
  }

  function formatDay(d) {
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  function isPreorder(product) {
    var text = ((product.title || '') + ' ' + (product.tags || []).join(' ') + ' ' + (product.description || '')).toLowerCase();
    return /pre[\s-]?order|presale|pre[\s-]?sale/.test(text);
  }

  function renderDelivery() {
    if (!deliveryText) return;
    document.querySelectorAll('main .buy-buttons-block').forEach(function (block) {
      if (block.closest('dialog, #cart-drawer')) return;
      var next = block.nextElementSibling;
      if (next && next.classList.contains('hl-delivery')) return;
      var box = document.createElement('p');
      box.className = 'hl-delivery';
      box.innerHTML = deliveryText;
      block.parentNode.insertBefore(box, block.nextSibling);
    });
  }

  function loadDelivery() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!match || match[1] === HANDLE) return;
    var country = window.Shopify && window.Shopify.country;
    if (country && country !== FREE_SHIP_COUNTRY) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'products/' + match[1] + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (product) {
        if (!product || product.vendor !== DELIVERY_VENDOR || !product.available || isPreorder(product)) return;
        var today = new Date();
        deliveryText =
          'Estimated delivery: <strong>' +
          formatDay(addBusinessDays(today, DELIVERY_MIN_DAYS)) +
          ' – ' +
          formatDay(addBusinessDays(today, DELIVERY_MAX_DAYS)) +
          '</strong>';
        ensureStyle();
        renderDelivery();
      })
      .catch(function () {});
  }

  function start() {
    new MutationObserver(function () {
      scheduleRender();
      renderDelivery();
    }).observe(document.body, { childList: true, subtree: true });
    loadDelivery();
    loadProduct().then(function () {
      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
